import { NgModule } from '@angular/core';
import { MatTooltipTruncateDirective } from './mat-tooltip-truncate.directive';

@NgModule({
  declarations: [MatTooltipTruncateDirective],
  exports: [MatTooltipTruncateDirective],
})
export class MatTooltipTruncateModule {}
